<div class="search_base">
    <div class="autocomplete-container">
    <div #searchField class="autocomplete-container"></div>
  </div>
  <!-- <img src="../../assets/images/search_icon.png" alt="seach" />
  <input
    type="text"
    class="form-control"
    #searchField
    [(ngModel)]="autoCompleteInput"
    placeholder="Search address, ZIP, neighborhood, school district, MLS Number (prefix with #)"
    name="autocompleteInput"
    required
    name="search property"
    tabindex="2"
    aria-label="enter address"
  /> -->
  <button
    type="button"
    mat-mini-fab
    class="show"
    [ngClass]="{ goActive: autoCompleteInput }"
    (click)="invokeEvent()"
    name="initiate search"
    aria-label="search address"
    tabindex="3"
  >
    Go
  </button>
</div>
